

















import { defineComponent, computed, PropType } from '@nuxtjs/composition-api';
import useWindowResize from '~/hooks/useResizeWindow';

type ListTypes = 'default' | 'bullet' | 'numbered' | 'plus' | 'minus';

export default defineComponent({
  name: 'List',
  props: {
    type: {
      type: String as PropType<ListTypes>,
      default: 'default'
    },
    items: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const { isDesktop } = useWindowResize();

    const listStyleClass = computed(() => {
      switch (props.type) {
        case 'bullet':
          return 'list-style-bullet';
        case 'numbered':
          return 'list-style-numbered';
        default:
          return '';
      }
    });

    const hasCustomListDecoration = computed(
      () => props.type === 'plus' || props.type === 'minus'
    );

    const customDecorationComponent = computed(() => {
      const componentName =
        props.type === 'plus' ? 'IconsPlusIcon' : 'IconsMinusIcon';
      let componentSizeSuffix = '12px';
      if (process.client) {
        componentSizeSuffix = isDesktop.value ? '16px' : '12px';
      }
      return componentName + componentSizeSuffix;
    });

    return {
      listStyleClass,
      hasCustomListDecoration,
      customDecorationComponent
    };
  }
});
